<template>
  <right-panel :datas="connects" @onClose="onClose" ref="right-panel">
    <div slot="header">
      <translate>View Members</translate>
    </div>
    <div slot="content" style="height: 100%">
      <el-table :data="detail.list" style="width: 100%; border: none">
        <el-table-column prop="name" :label="attrText.userName"></el-table-column>
        <el-table-column prop="account" :label="attrText.account"></el-table-column>
      </el-table>
      <div class="pagination" v-if="detail.totalCount > 10">
        <el-pagination layout="prev, pager, next" :total="detail.totalCount" :page-size="10"
                      :current-page.sync="detail.currentPage"
                      @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button @click="$refs['right-panel'].onClose()">
        <translate>Close</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'WorkgroupAddGroup',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        detail: {
          groupId: '',
          list: [],
          totalCount: 0,
          currentPage: 1
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    created () {
    },
    methods: {
      // 提取翻译文本
      getTranslateText () {
        return {
          'userName': this.$gettext('User Name'),
          'account': this.$gettext('Account')
        }
      },
       // 获取群组成员列表
      getTeamGroupMembers (page, total) {
        this.detail.currentPage = page || 1
        let params = {
          id: this.connects.id,
          data: {
            page: page || 1
          }
        }
        if (total) { params.data.total = total }
        this.loading = true
        this.$store.dispatch(STORE_CONST.TEAM.GET_GROUP_MEMBERS, params).then(res => {
          this.loading = false
          this.detail = Object.assign({}, {
            list: res.objects,
            totalCount: res.total,
            currentPage: page || res.page
          })
        }, () => {
          this.loading = false
        })
      },
      // 关闭添加群组
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      },
      // 分页改变
      handlePageChange (page) {
        this.detail.currentPage = page
        this.getTeamGroupMembers(page, this.detail.totalCount)
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          console.log('---items', this.items)
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
          this.getTeamGroupMembers()
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>
<style lang='scss' rel="stylesheet/scss">
  .groupForm {
    .auto-complete {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// workgroup-view-group.vue?27002bb6